import { render, staticRenderFns } from "./phone_login.vue?vue&type=template&id=a4226f86&scoped=true&"
import script from "./phone_login.vue?vue&type=script&lang=js&"
export * from "./phone_login.vue?vue&type=script&lang=js&"
import style0 from "./phone_login.vue?vue&type=style&index=0&id=a4226f86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4226f86",
  null
  
)

export default component.exports